/**
 * Presence heartbeat — keep `users.last_seen_at` warm and Redis presence
 * key alive while the user has the app open.
 *
 * One module-level interval so multiple page renders don't stack ticks.
 * Pauses when the tab is hidden so we don't burn requests on a screen
 * the user can't see.
 */

import { api } from '../api.js';
import { auth } from '../auth.js';

const INTERVAL_MS = 45_000;
let _started = false;
let _timer = null;

async function tick() {
  if (!auth.isAuthenticated()) return;
  if (document.hidden) return;
  try {
    await api('/presence/heartbeat', { method: 'POST' });
  } catch {
    // Best-effort; ignore so a backend blip doesn't surface as a toast.
  }
}

export function ensurePresenceHeartbeat() {
  if (_started) return;
  _started = true;
  tick();
  _timer = setInterval(tick, INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) tick();
  });
}

export function stopPresenceHeartbeat() {
  if (_timer) clearInterval(_timer);
  _timer = null;
  _started = false;
}
